export default __webpack_public_path__ + "static/media/felicitations-form.637d813f.svg";